import { renderToString } from 'react-dom/server'

export const printReactComponent = (rendererComponent: JSX.Element) => () => {
  const printWindow = window.open('', '', 'height=800,width=1200')!
  printWindow.document.write(renderToString(rendererComponent))
  printWindow.document.close()
  printWindow.print()
}
